export class Fair {
  public fairCode: string;
  public cartUrl: string;
  public shopUrl: string;
  public firstPossibleDeliveryDate?: Date;
  public lastPossibleDeliveryDate?: Date;


  public static fromJson(fairJson: string): Fair {
    const fair: Fair = JSON.parse(fairJson);

    if (fair.firstPossibleDeliveryDate) {
      fair.firstPossibleDeliveryDate = new Date(fair.firstPossibleDeliveryDate);
      fair.firstPossibleDeliveryDate.setHours(0, 0, 0, 0);
    }
    if (fair.lastPossibleDeliveryDate) {
      fair.lastPossibleDeliveryDate = new Date(fair.lastPossibleDeliveryDate);
      fair.lastPossibleDeliveryDate.setHours(23, 59, 59, 999);
    }

    return fair;
  }
}
